import axios from 'axios';

import { ROOT, ADMIN_URL, SET_USERS, SET_CURRENT_USER, INVITE_URL, SET_GROUPS, GROUPS_URL } from '../../constants';

export const getAdmin = () => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${ADMIN_URL}`)
      .then((response) => {
        dispatch(setUsers(response.data.filter((user) => user.first_name.length || user.last_name.length)));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
  };
};

export const inviteUser = (payload) => {
  return async () => {
    axios.post(`${ROOT}${INVITE_URL}`, payload).catch((error) => {
      const { response } = error;
      const { data } = response;
      return { success: false, data };
    });
  };
};

export const getGroups = () => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${GROUPS_URL}`)
      .then((response) => {
        dispatch(setGroups(response.data));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        return { success: false, data };
      });
  };
};

export const editGroup = (body, id) => {
  return async (dispatch) => {
    axios
      .patch(`${ROOT}${GROUPS_URL}${id}/`, body)
      .then((response) => {
        dispatch(getGroups());
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  };
};

export const newGroup = (body) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${GROUPS_URL}`, body)
      .then(() => {
        dispatch(getGroups());
      })
      .catch((error) => {
        return error;
      });
  };
};

export const deleteGroup = (id) => {
  return async () => {
    axios.delete(`${ROOT}${GROUPS_URL}${id}/`).catch((error) => {
      return error;
    });
  };
};

export const setUsers = (users) => {
  return {
    type: SET_USERS,
    users,
  };
};
export const setUser = (user) => {
  return {
    type: SET_CURRENT_USER,
    user,
  };
};
export const setGroups = (groups) => {
  return {
    type: SET_GROUPS,
    groups,
  };
};
